{
  "common.close": "إغلاق",
  "common.athleteFallback": "الرياضي {id}",
  "splash.title": "{app} — تصوير متحرك للأنشطة",
  "splash.tagline": "خرائط متحركة لبيانات&nbsp;Strava الخاصة بك",
  "splash.demo": "عرض تجريبي",
  "tab.query.title": "خريطة {name}",
  "tab.query.heading": "استعلام الأنشطة:",
  "tab.query.optDays": "الأيام الأخيرة",
  "tab.query.optActivities": "الأنشطة الأخيرة",
  "tab.query.optIds": "معرّفات الأنشطة",
  "tab.query.optDates": "نطاق تاريخ",
  "tab.query.idsPlaceholder": "أدخل معرّفات الأنشطة هنا",
  "tab.query.after": "بعد:",
  "tab.query.before": "قبل:",
  "tab.query.autozoom": "تكبير تلقائي <i class=\"hf hf-bullseye\"></i> إلى نتيجة الاستعلام بعد الاستيراد",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> استعلام",
  "tab.query.createAccount": "أنشئ حسابًا و/أو سجّل الدخول.",
  "tab.query.sports": "الرياضات:",
  "tab.query.allSports": "كل الرياضات",
  "tab.query.sportsExcept": "الكل ما عدا",
  "tab.query.sportsNone": "لا شيء",
  "tab.query.loadingSports": "جارٍ تحميل الرياضات…",
  "tab.query.sportsFailed": "تعذّر تحميل رياضات هذه الخريطة",
  "tab.query.noSports": "لا توجد أنشطة بعد",
  "tab.activities.title": "الأنشطة المعروضة",
  "tab.activities.clearSelection": "مسح التحديد",
  "tab.activities.renderSelected": "عرض المحدد",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> تكبير إلى التحديد",
  "tab.controls.title": "إعدادات الطبقة",
  "tab.controls.timescale": "المقياس الزمني <i>&tau;</i>",
  "tab.controls.timescaleHint": "سرعة التشغيل",
  "tab.controls.period": "الدورة <i>T</i>",
  "tab.controls.periodHint": "النشاط ~ النموذج",
  "tab.controls.dotSize": "حجم النقطة",
  "tab.controls.pathWidth": "عرض المسار",
  "tab.controls.pathWidthHint": "الصفر يخفي المسارات",
  "tab.controls.colors": "الألوان",
  "tab.controls.colorsHint": "تدوير لوحة الألوان",
  "tab.controls.shadows": "الظلال",
  "tab.profile.loginTitle": "تسجيل الدخول",
  "tab.profile.anonNote": "سجّل الدخول باستخدام Strava لترى أنشطتك، ولإدارة حسابك في Heatflask.",
  "tab.profile.loginLink": "تسجيل الدخول باستخدام Strava",
  "tab.profile.editOnStrava": "عدّل ملفك الشخصي على Strava",
  "tab.profile.indexNote": "نفهرس ملخصات أنشطتك للوصول إليها بسرعة.",
  "tab.profile.viewIndex": "عرض الفهرس",
  "tab.profile.sharedMaps": "الخرائط المشتركة",
  "tab.profile.sharedMapsNote": "إيقاف: أنت وحدك ترى أنشطتك على Heatflask. تشغيل: كل من لديه رابط خريطتك يمكنه رؤية الأنشطة التي جعلتها عامة على Strava. تبقى أنشطتك الخاصة لك في الحالتين. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">كيف تعمل الخصوصية</a>",
  "tab.profile.logout": "تسجيل الخروج",
  "tab.profile.deleteAccount": "حذف الحساب",
  "tab.profile.deleteConfirm": "هل تريد حذف حسابك في Heatflask؟\n\nسيؤدي هذا إلى إزالة أنشطتك المفهرسة وإلغاء وصول Heatflask إلى بياناتك في Strava. لا يمكن التراجع عن ذلك.",
  "tab.profile.languageHeading": "اللغة",
  "tab.profile.languageAuto": "تلقائي",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">ساعدنا في تصحيح الترجمات أو إضافة ترجمات جديدة!</a>",
  "tab.profile.unitsHeading": "الوحدات",
  "tab.profile.unitsAuto": "تلقائي",
  "tab.profile.unitsMetric": "متري (كم، م)",
  "tab.profile.unitsImperial": "إمبراطوري (ميل، قدم)",
  "tab.profile.textSizeHeading": "حجم النص",
  "tab.profile.textSmaller": "أصغر",
  "tab.profile.textReset": "عادي",
  "tab.profile.textLarger": "أكبر",
  "tab.profile.mapDefaultsHeading": "إعدادات الخريطة الافتراضية",
  "tab.profile.mapDefaultsNote": "ابدأ بهذه الخريطة الأساسية والتضاريس وإعدادات الطبقة كلما فتحت خريطة لا يحدد رابطها إعداداته الخاصة. الروابط التي تشاركها تعرض دائمًا ما تراه أنت تمامًا.",
  "tab.profile.mapDefaultsSave": "حفظ كإعداداتي الافتراضية",
  "tab.profile.mapDefaultsForget": "نسيان",
  "tab.info.title": "معلومات",
  "tab.info.controlsHeading": "عناصر التحكم",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + سحب",
  "tab.info.shiftDragDesc": "حدّد الأنشطة داخل مربع. على شاشة اللمس، اضغط <i class=\"hf-object-group\"></i> أولًا، ثم اسحب بإصبع واحد. يعرض آخر نشاط محدد تفاصيله، وتنتقل قائمة الأنشطة إليه.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + سحب",
  "tab.info.ctrlDragDesc": "دوّر الخريطة وأمِلها ثلاثيًا، أو استخدم إصبعين",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "فتح الشريط الجانبي أو إغلاقه",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "تبويب الشريط الجانبي السابق أو التالي",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "إغلاق الشريط الجانبي",
  "tab.info.liveUrlHeading": "رابط حي",
  "tab.info.liveUrlDesc": "يُحفظ عرض الخريطة وإعدادات الحركة في رابط الصفحة، فيرى كل من تشاركه معه العرض نفسه.",
  "tab.info.videoHeading": "تصدير الفيديو",
  "tab.info.videoDesc": "يسجّل الزر <i class=\"hf-video-camera\"></i> الحركة كملف MP4: اضغطه، واضبط المربع فوق جزء الخريطة الذي تريده، ثم اضغطه مجددًا للتسجيل. تُسجَّل دورة كاملة واحدة من الحركة، فيتكرر الفيديو بسلاسة؛ والدورة الأطول من {max} ثانية (أطول فيديو يقبله Strava) تُقطع عند {max}.",
  "tab.info.contributeHeading": "المساهمة",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> ادعمنا على GitHub",
  "tab.info.contactsHeading": "جهات الاتصال",
  "map.basemapAndTerrain": "الخريطة الأساسية والتضاريس",
  "map.pauseAnimation": "إيقاف الحركة مؤقتًا",
  "map.resumeAnimation": "استئناف الحركة",
  "capture.record": "تسجيل فيديو (دورة {period} ث)",
  "capture.recordTruncated": "تسجيل فيديو (الدورة الواحدة {period} ث؛ ستُسجَّل أول {max} ث فقط)",
  "capture.recordArea": "سجّل المنطقة داخل المربع",
  "capture.stop": "إيقاف التسجيل",
  "capture.selectionTooSmall": "التحديد صغير جدًا",
  "capture.saved": "حُفظ {name} ({size})",
  "capture.cancelled": "أُلغي التسجيل",
  "capture.failed": "فشل التسجيل: {error}",
  "capture.loadingEncoder": "جارٍ تحميل المرمّز…",
  "capture.waitingForMap": "بانتظار تحميل الخريطة…",
  "capture.encoding": "جارٍ الترميز… {percent}%",
  "capture.finalizing": "جارٍ الإنهاء…",
  "share.title": "شارك رابطًا إلى هذه الخريطة",
  "share.copied": "نُسخ الرابط",
  "share.copiedUnshared": "نُسخ الرابط، لكن خريطتك غير مشتركة، فلا يستطيع أحد غيرك فتحها. فعّل «الخرائط المشتركة» لتغيير ذلك.",
  "share.unshared": "خريطتك غير مشتركة، فلا يستطيع أحد غيرك فتح هذا الرابط. فعّل «الخرائط المشتركة» لتغيير ذلك.",
  "share.copyThis": "انسخ هذا الرابط:",
  "update.available": "يتوفر إصدار جديد من Heatflask.",
  "update.reload": "إعادة التحميل",
  "import.title": "جارٍ الاستيراد",
  "import.stop": "إيقاف",
  "import.stopping": "جارٍ الإيقاف…",
  "import.contacting": "جارٍ الاتصال بـ Strava…",
  "import.countOf": "الأنشطة: {received} من {total}",
  "import.count": "الأنشطة: {received}",
  "import.waitStrava": "متوقف مؤقتًا حتى {time} بسبب حد التنزيل في Strava. اترك هذه الصفحة مفتوحة؛ إعادة التحميل لن تسرّع الأمر.",
  "import.waitRationed": "استنفدت التنزيلات السريعة لهذا اليوم. يستمر الباقي عند {time} بوتيرة أبطأ. اترك هذه الصفحة مفتوحة.",
  "import.dailyLimit": "استُنفد حد التنزيل اليومي في Strava. حاول مرة أخرى بعد {time}.",
  "import.dailyRationed": "استنفدت حصتك من تنزيلات Strava لهذا اليوم. حاول مرة أخرى بعد {time}.",
  "import.noActivitiesYet": "لا توجد أنشطة في حسابك على Strava بعد. سجّل نشاطًا أو ارفعه على Strava وسيظهر هنا.",
  "table.noActivities": "لا توجد أنشطة",
  "table.untitled": "(بلا عنوان)",
  "activities.pageTitle": "{app} — فهرس الأنشطة",
  "activities.heading": "فهرس الأنشطة",
  "activities.fetching": "جارٍ جلب الأنشطة...",
  "activities.rateLimit": "بلغنا حد الطلبات في Strava؛ سنستأنف عند {time}",
  "activities.noData": "عذرًا، لا توجد بيانات &#128577;",
  "activities.colServerCache": "المسار مخزّن على الخادم (Mongo)",
  "activities.colBrowserCache": "المسار مخزّن في هذا المتصفح",
  "activities.cachedServer": "مسار {id} مخزّن على الخادم",
  "activities.notCachedServer": "مسار {id} غير مخزّن على الخادم",
  "activities.cachedBrowser": "مسار {id} مخزّن في هذا المتصفح",
  "activities.notCachedBrowser": "مسار {id} غير مخزّن في هذا المتصفح",
  "sport.AlpineSki": "تزلج على المنحدرات",
  "sport.BackcountrySki": "تزلج في البراري",
  "sport.Badminton": "ريشة طائرة",
  "sport.Basketball": "كرة السلة",
  "sport.Canoeing": "تجديف بالكانو",
  "sport.Cricket": "كريكيت",
  "sport.Crossfit": "كروسفيت",
  "sport.Dance": "رقص",
  "sport.EBikeRide": "ركوب دراجة كهربائية",
  "sport.Elliptical": "جهاز إهليلجي",
  "sport.EMountainBikeRide": "ركوب دراجة جبلية كهربائية",
  "sport.Golf": "غولف",
  "sport.GravelRide": "ركوب على الحصى",
  "sport.Handcycle": "دراجة يدوية",
  "sport.HighIntensityIntervalTraining": "تدريب متقطع عالي الشدة",
  "sport.Hike": "مشي لمسافات طويلة",
  "sport.IceSkate": "تزلج على الجليد",
  "sport.InlineSkate": "تزلج بالعجلات",
  "sport.Kayaking": "تجديف بالكاياك",
  "sport.Kitesurf": "تزلج شراعي",
  "sport.MountainBikeRide": "ركوب دراجة جبلية",
  "sport.NordicSki": "تزلج نوردي",
  "sport.Padel": "بادل",
  "sport.PhysicalTherapy": "علاج طبيعي",
  "sport.Pickleball": "بيكلبول",
  "sport.Pilates": "بيلاتس",
  "sport.Racquetball": "راكيت بول",
  "sport.Ride": "ركوب دراجة",
  "sport.RockClimbing": "تسلق الصخور",
  "sport.RollerSki": "تزلج بالعجلات على الطرق",
  "sport.Rowing": "تجديف",
  "sport.Run": "جري",
  "sport.Sail": "إبحار",
  "sport.Skateboard": "لوح تزلج",
  "sport.Snowboard": "تزلج على الثلج بلوح",
  "sport.Snowshoe": "مشي بأحذية الثلج",
  "sport.Soccer": "كرة القدم",
  "sport.Squash": "سكواش",
  "sport.StairStepper": "جهاز الدرج",
  "sport.StandUpPaddling": "تجديف وقوفًا",
  "sport.Surfing": "ركوب الأمواج",
  "sport.Swim": "سباحة",
  "sport.TableTennis": "كرة الطاولة",
  "sport.Tennis": "تنس",
  "sport.TrailRun": "جري في المسارات",
  "sport.Velomobile": "دراجة مغطاة",
  "sport.VirtualRide": "ركوب دراجة افتراضي",
  "sport.VirtualRow": "تجديف افتراضي",
  "sport.VirtualRun": "جري افتراضي",
  "sport.Volleyball": "كرة الطائرة",
  "sport.Walk": "مشي",
  "sport.WeightTraining": "تدريب بالأثقال",
  "sport.Wheelchair": "كرسي متحرك",
  "sport.Windsurf": "تزلج شراعي على الماء",
  "sport.Workout": "تمرين",
  "sport.Yoga": "يوغا"
}
